"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowDown01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { cn, PopoverTrigger } from "@workspace/frontend-ui";
import type { FC } from "react";
import type { SelectedProvider } from "../../../types";
import ProviderDropdownTriggerContent from "./ProviderDropdownTriggerContent";

type Props = {
  isVisible: boolean;
  enabledProviders: SelectedProvider[];
  onRemoveProvider: (provider: SelectedProvider) => void;
  onClearProviders: () => void;
};

const ProviderDropdownTrigger: FC<Props> = ({
  isVisible,
  enabledProviders,
  onRemoveProvider,
  onClearProviders,
}) => (
  <PopoverTrigger asChild>
    <div
      className={cn(
        "border flex h-full rounded-xl justify-start px-3 items-center",
        "w-full md:w-40 h-10 mt-1 md:mt-0! select-none",
        isVisible && "md:w-70! border-primary",
        !isVisible && "border-muted",
      )}
    >
      <ProviderDropdownTriggerContent
        enabledProviders={enabledProviders}
        onRemoveProvider={onRemoveProvider}
        onClearProviders={onClearProviders}
      />
      <div className="w-1" />
      <HugeiconsIcon
        icon={ArrowDown01Icon}
        className={cn(
          "transform text-muted-foreground",
          isVisible && "rotate-180",
        )}
      />
    </div>
  </PopoverTrigger>
);

export default ProviderDropdownTrigger;
